//路由配置
import PortalPage from '../module_biz/portal/page/PortalPage';
import RefPage from '../module_biz/QueryScheme/page/RefPage';
import SearchPage from '../module_biz/QueryScheme/page/SearchPage';
import SearchPageSetting from '../module_biz/QueryScheme/page/SearchPageSetting';
export default [
    {
        path: '/querySchemePortal',
        component: PortalPage
    },
    {
        path: '/reference',
        component: RefPage,
        cache: true
    },
    {
        path: '/queryScheme',
        component: SearchPage,
        cache: true,
        cacheKey: 'queryScheme'
    },
    {
        path: '/querySchemeSetting',
        component: SearchPageSetting
    }
]
